var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"数字人","width":"100rem","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('video',{staticStyle:{"width":"100%","max-height":"70rem"},attrs:{"autoplay":"","controls":"","src":_vm.videoUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }